<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <PendingSamples :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <ReceivingSamples :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <SamplesWaitingForAnalysis :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <SamplesInAnalysis :items-per-page="5" />
    </div>
  </div>
</template>
<script>
import PendingSamples from '@views/admin/samples/pendingsamples/view';
import ReceivingSamples from '@views/admin/samples/receivingsamples/view';
import SamplesInAnalysis from '@views/admin/samples/samplesinanalysis/view';
import SamplesWaitingForAnalysis from '@views/admin/samples/waitingforanalysissamples/view';

export default {
  name: 'LaboratoryScientistDashboard',
  components: {
    PendingSamples,
    ReceivingSamples,
    SamplesInAnalysis,
    SamplesWaitingForAnalysis
  }
};
</script>
<style scoped>

</style>
